import { AnalyticsFieldSearchResponseSchema, AnalyticsFieldSearchSchema, } from '../analytics/fields.js';
import { FlowAnalyticsQuerySchema } from '../analytics/flow.js';
import { OmniFilterSchema } from '../analytics/omni/filters.js';
import { AnalyticsQueryResponseSchema } from '../analytics/query.js';
import { AssistantChatMessageSchema, AssistantChatSessionListItemSchema, AssistantChatSessionListResponseSchema, AssistantVoiceCallConversationSchema, } from '../assistant/chatSession.js';
import { AssistantDefinitionSchema } from '../assistant/definition.js';
import { AssistantListResponseSchema, AssistantSchema } from '../assistant/read.js';
import { AssistantToolDefinitionSchema } from '../assistant/tool.js';
import { AssistantVoiceCallSchema } from '../assistant/voiceCall.js';
import { ConnectionSchema } from '../connection/connection.js';
import { ConnectionListResponseSchema } from '../connection/routes.js';
import { EhrInformationListResponseSchema } from '../ehrInformation/list.js';
import { EncounterListResponseSchema } from '../encounter/list.js';
import { FeedExpectedSourceFieldsSchema, FeedSchema } from '../feed/read.js';
import { NotificationContentListResponseSchema, NotificationContentSchema, } from '../notification/content.js';
import { NotificationIntentSchema } from '../notification/intent.js';
import { NotificationRequestListResponseSchema } from '../notification/request.js';
import { NotificationScheduleListResponseSchema, NotificationScheduleWithTimingsSchema, } from '../notification/schedule.js';
import { NotificationSchemeFullSchema, NotificationSchemeListResponseSchema, } from '../notification/scheme.js';
import { OrganizationListResponseSchema } from '../organization/list.js';
import { OrganizationReadResponseSchema, OrganizationSchema } from '../organization/read.js';
import { PracticeListResponseSchema } from '../practice/list.js';
import { PrevisitFormSetListResponseSchema, PrevisitFormSetSchema, PrevisitFormSummarySchema, } from '../previsitForm/setResponse.js';
import { PrevisitFormTemplateListResponseSchema, PrevisitFormTemplateSchema, } from '../previsitForm/templateResponse.js';
import { ReferenceTableListResponseSchema, ReferenceTableRowsResponseSchema, ReferenceTableSummarySchema, } from '../referenceTable/read.js';
import { ScenarioListResponseSchema, ScenarioSchema } from '../scenario/read.js';
/**
 * The schemas primary names in its published surface, keyed by that name.
 *
 * A client that knows a name can reach the schema behind it directly, rather than pulling a
 * component out of a generated document. Naming them in one place is what keeps the two the same
 * thing.
 *
 * Matching the routes published alongside them.
 */
export const PRIMARY_API_SCHEMAS_BY_NAME = {
    AnalyticsFieldSearch: AnalyticsFieldSearchSchema,
    AnalyticsFieldSearchResponse: AnalyticsFieldSearchResponseSchema,
    AnalyticsQueryResponse: AnalyticsQueryResponseSchema,
    Assistant: AssistantSchema,
    AssistantChatMessage: AssistantChatMessageSchema,
    AssistantChatSessionListItem: AssistantChatSessionListItemSchema,
    AssistantChatSessionListResponse: AssistantChatSessionListResponseSchema,
    AssistantDefinition: AssistantDefinitionSchema,
    AssistantListResponse: AssistantListResponseSchema,
    AssistantToolDefinition: AssistantToolDefinitionSchema,
    AssistantVoiceCall: AssistantVoiceCallSchema,
    AssistantVoiceCallConversation: AssistantVoiceCallConversationSchema,
    Connection: ConnectionSchema,
    ConnectionListResponse: ConnectionListResponseSchema,
    Feed: FeedSchema,
    FeedExpectedSourceFields: FeedExpectedSourceFieldsSchema,
    FlowAnalyticsQuery: FlowAnalyticsQuerySchema,
    JsonValue: AnalyticsQueryResponseSchema.shape.rows.element.valueType,
    OmniFilter: OmniFilterSchema,
    NotificationContent: NotificationContentSchema,
    NotificationContentListResponse: NotificationContentListResponseSchema,
    NotificationIntent: NotificationIntentSchema,
    NotificationSchedule: NotificationScheduleWithTimingsSchema,
    NotificationScheduleListResponse: NotificationScheduleListResponseSchema,
    NotificationScheme: NotificationSchemeFullSchema,
    NotificationSchemeListResponse: NotificationSchemeListResponseSchema,
    Organization: OrganizationSchema,
    OrganizationListResponse: OrganizationListResponseSchema,
    OrganizationReadResponse: OrganizationReadResponseSchema,
    PracticeListResponse: PracticeListResponseSchema,
    PrevisitFormSet: PrevisitFormSetSchema,
    PrevisitFormSetListResponse: PrevisitFormSetListResponseSchema,
    PrevisitFormSummary: PrevisitFormSummarySchema,
    PrevisitFormTemplate: PrevisitFormTemplateSchema,
    PrevisitFormTemplateListResponse: PrevisitFormTemplateListResponseSchema,
    ReferenceTableListResponse: ReferenceTableListResponseSchema,
    ReferenceTableRowsResponse: ReferenceTableRowsResponseSchema,
    ReferenceTableSummary: ReferenceTableSummarySchema,
    Scenario: ScenarioSchema,
    ScenarioListResponse: ScenarioListResponseSchema,
    EhrInformationListResponse: EhrInformationListResponseSchema,
    EncounterListResponse: EncounterListResponseSchema,
    NotificationRequestListResponse: NotificationRequestListResponseSchema,
};
//# sourceMappingURL=schemas.js.map